/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './confirmEmail.defs.js'
export { main as default } from './confirmEmail.defs.js'
